var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "actions-container",
      class: { "horizontal-layout": _vm.isHorizontalView },
    },
    [
      _vm.showAccount
        ? _c("AccountPaidStatus", {
            staticClass: "pt-1",
            on: {
              "open-account-pay": function ($event) {
                return _vm.$emit("open-account-pay")
              },
            },
          })
        : _vm._e(),
      _c(
        "v-btn",
        {
          attrs: { outlined: "", fab: "", small: "", color: "accent" },
          on: {
            click: function ($event) {
              return _vm.$emit("info-action")
            },
          },
        },
        [_c("v-icon", [_vm._v(_vm._s(_vm.mdiInformationOutline))])],
        1
      ),
      _c(
        "v-tooltip",
        {
          attrs: { right: "", "open-delay": "500" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                            disabled: _vm.isLoading || !_vm.hasUnsavedChanges,
                            loading: _vm.isBackendBusy,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("save-changes")
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_c("v-icon", [_vm._v("save")])],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.day6Resource.save))])]
      ),
      _c(
        "v-tooltip",
        {
          attrs: { right: "", "open-delay": "500" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                            disabled: _vm.isLoading || !_vm.isEditMode,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("open-character-browser")
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_c("v-icon", [_vm._v("folder")])],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.day6Resource.browserCharacters))])]
      ),
      _c("ShareAction", {
        attrs: {
          isStacked: !_vm.isHorizontalView,
          isLoading: _vm.isLoading,
          isPendingShare: _vm.isPendingShare,
          isSharing: _vm.isSharing,
          shareLevel: _vm.shareLevel,
          isQueryingShareLevel: _vm.isQueryingShareLevel,
        },
        on: {
          "share-character": function ($event) {
            return _vm.$emit("share-character")
          },
        },
      }),
      _c(
        "v-tooltip",
        {
          attrs: { right: "", "open-delay": "500" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                            disabled:
                              _vm.isLoading ||
                              _vm.isNotEditPoseMode ||
                              _vm.isBackendBusy ||
                              (_vm.isEditMode &&
                                (_vm.isPendingBuild || _vm.isProcessingBuild)),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("toggle-build-pose")
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", [
                        _vm._v(
                          _vm._s(
                            _vm.isPoseMode
                              ? _vm.mdiHuman
                              : "$vuetify.icons.poseCharacter"
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.buildPoseHint))])]
      ),
      _c(
        "v-tooltip",
        {
          attrs: { right: "", "open-delay": "500" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                            disabled:
                              _vm.isLoading ||
                              _vm.isNotEditPoseMode ||
                              _vm.isBackendBusy,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("estimate-pose")
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_c("v-icon", [_vm._v("$estimatePose")])],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.day6Resource.detectPose))])]
      ),
      _c(
        "v-tooltip",
        {
          attrs: { right: "", "open-delay": "500" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                            disabled:
                              _vm.isLoading ||
                              !_vm.isEditMode ||
                              _vm.isBackendBusy ||
                              _vm.isPendingBuild,
                            loading: _vm.isEditMode && _vm.isProcessingBuild,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("start-download")
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", [
                        _vm._v(
                          _vm._s(
                            _vm.isPendingBuild
                              ? _vm.mdiCalendarClock
                              : "download"
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.day6Resource.downloadHint))])]
      ),
      _c(
        "v-tooltip",
        {
          attrs: { right: "", "open-delay": "500" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                            disabled:
                              _vm.isLoading ||
                              !_vm.isEditMode ||
                              _vm.isBackendBuildingProcessing,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("preview-generated")
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_c("v-icon", [_vm._v(_vm._s(_vm.mdiEyeOutline))])],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.day6Resource.previewGenerated))])]
      ),
      _c(
        "v-tooltip",
        {
          attrs: { right: "", "open-delay": "500" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        outlined: "",
                        fab: "",
                        small: "",
                        color: "accent",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("mailing-list")
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("email")])],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.day6Resource.mailingList))])]
      ),
      _c(
        "v-tooltip",
        {
          attrs: { right: "", "open-delay": "500" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                            disabled:
                              _vm.isLoading ||
                              !_vm.isEditMode ||
                              _vm.isBackendBuildingProcessing,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("restore-dimensions")
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_c("v-icon", [_vm._v(_vm._s(_vm.mdiRestore))])],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(_vm._s(_vm.day6Resource.reset))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }